var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import { getUserData } from "../../../actions/user";
import UserHeader from "../../../components/Library/UserHeader";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import SummaryCard from "../../../components/Library/SummaryCard/SummaryCard";
import SavedStoriesEmpty from "./SavedStoriesEmpty";

import styles from "../UserSettings/UserSettings.css";

var SavedStories = function (_Component) {
  _inherits(SavedStories, _Component);

  function SavedStories() {
    _classCallCheck(this, SavedStories);

    return _possibleConstructorReturn(this, (SavedStories.__proto__ || Object.getPrototypeOf(SavedStories)).apply(this, arguments));
  }

  _createClass(SavedStories, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getUserData();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        Layout,
        { className: styles.root, includeHeader: true, headerComponent: React.createElement(UserHeader, { person: { display_name: this.props.userSettings.data.profileInfo.display_name } }) },
        React.createElement(
          Sidebar,
          { className: styles.sidebar },
          React.createElement(
            Link,
            { to: "/users/saved-stories", className: classNames(styles.sidebarLinks, styles.active) },
            "Saved Stories"
          ),
          React.createElement(
            Link,
            { to: "/users/settings", className: styles.sidebarLinks },
            "Account"
          )
        ),
        React.createElement(
          Content,
          null,
          this.props.userSettings.data.profileInfo.saved_stories.map(function (savedStory, index) {
            return React.createElement(SummaryCard, { key: index, story: savedStory, showSaveTag: true });
          }),
          this.props.userSettings.data.profileInfo.saved_stories.length === 0 ? React.createElement(SavedStoriesEmpty, null) : null
        )
      );
    }
  }]);

  return SavedStories;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUserData: bindActionCreators(getUserData, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedStories);


// WEBPACK FOOTER //
// ./src/users/components/SavedStories/SavedStories.js